import { CustomFieldFilterOptions } from "../../enums/filters-and-searchs/CustomFieldFilterOptions";

export const CustomFieldsFilterSearch = new Map<number, string>([
    [CustomFieldFilterOptions.None, 'None'],
    [CustomFieldFilterOptions.DeletedCustomFields, 'Deleted Custom Fields'],
]);